import { createFileRoute } from '@tanstack/react-router'
import PlanImportRevision from '../../../../../../../containers/plan-import-revision'
import { plansImportRevisionSearchSchema } from '../../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/_plans/importRevision/$planId/'
)({
  component: RouteComponent,
  validateSearch: plansImportRevisionSearchSchema
})

function RouteComponent() {
  return <PlanImportRevision />
}
